var map = {
	"./config.dev": 61493,
	"./config.dev.js": 61493,
	"./config.js": 31132,
	"./config.poc1": 41945,
	"./config.poc1.js": 41945,
	"./config.poc2": 30944,
	"./config.poc2.js": 30944,
	"./config.prod": 96765,
	"./config.prod.js": 96765,
	"./config.prodtest": 69701,
	"./config.prodtest.js": 69701,
	"./config.test": 83196,
	"./config.test.js": 83196
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42574;